import React from 'react';
import BlazeLink from '../components/BlazeLink';
const getWrappedValueWithLink = (value, link, keyPrefix = '') => {
  if (Array.isArray(value)) {
    const arrayResults = value.map((arrValue, index) => {
      const {
        keyField,
        url
      } = arrValue;
      const keyValue = arrValue[keyField];
      const isLastItem = index === value.length - 1;
      const keyFieldValue = isLastItem ? keyValue : /*#__PURE__*/React.createElement(React.Fragment, null, keyValue, ", ");
      return url ? /*#__PURE__*/React.createElement(BlazeLink, {
        key: [keyPrefix, index].join('-'),
        href: url
      }, /*#__PURE__*/React.createElement(React.Fragment, null, keyFieldValue, " ")) : /*#__PURE__*/React.createElement(React.Fragment, null, keyFieldValue, " ");
    });
    return arrayResults.length ? arrayResults : null;
  }
  return link ? /*#__PURE__*/React.createElement(BlazeLink, {
    href: link
  }, value) : value;
};
export default getWrappedValueWithLink;
//# sourceMappingURL=get-wrapped-value-with-link.js.map